

















import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";

import { DrivewealthWizardStep, FeatureFlags } from "@/shared/types";
import RequiredDisclosures from "./RequiredDisclosures.vue";
import TermsAndConditions from "./TermsAndConditions.vue";
import CustomerSignature from "./CustomerSignature.vue";
import ManagedAccountConfirmPortfolio from "@/shared/components/investments/drivewealth/ManagedAccountConfirmPortfolio.vue";
import ManagedAccountQuestions from "@/shared/components/investments/drivewealth/ManagedAccountQuestions.vue";
import InvestmentAccountTypeSelector from "@/shared/components/investments/drivewealth/InvestmentAccountTypeSelector.vue";
import InvestmentAccountTypeChange from "@/shared/components/investments/drivewealth/InvestmentAccountTypeChange.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import DrivewealthCuratedRtq from "@/employee/components/investments/drivewealth/DrivewealthCuratedRtq.vue";
import SweepPage from "@/employee/components/investments/drivewealth/SweepPage.vue";
import SweepPageV2 from "@/employee/components/investments/drivewealth/SweepPageV2.vue";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    InvestmentAccountTypeChange,
    InvestmentAccountTypeSelector,
    RequiredDisclosures,
    TermsAndConditions,
    CustomerSignature,
    ManagedAccountConfirmPortfolio,
    ManagedAccountQuestions,
    RiskDisclaimer,
    SweepPage,
    SweepPageV2,
    DrivewealthCuratedRtq
  }
})
export default class SharedAccountCreationPage extends Vue {
  @Prop({ required: true })
  step: DrivewealthWizardStep; // from the url

  @Prop({ required: false, default: false })
  isPreenrollment: boolean;

  @Prop({required: false})
  isCreatingAccount: boolean;

  @Prop({required: false})
  isSavingAccountClaims: boolean;

  @Prop({ required: false, default: false })
  isUserOnboarding: boolean;

  @Prop({ required: true })
  routeName: string;

  @Prop({ required: false, default: () => ({}) })
  routeParams: object;

  @Prop({ required: true })
  hasAnAccount: boolean;

  @Prop({ required: false })
  isAccountClaimsWorkflow: boolean;

  @Prop({ required: false })
  accountId: number;

  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();

  mounted (): void {
    const location = this.createLocation(DrivewealthWizardStep.SelectAccountType);
    this.drivewealthWizardStore.startWizard(location, this.isAccountClaimsWorkflow, this.accountId);

    this.onStepChanged();
    if (!this.drivewealthWizardStore.isEnrollmentLoaded) {
      this.drivewealthWizardStore.loadExistingPreenrollment({});
    }
  }

  createLocation (step: DrivewealthWizardStep) {
    return {
      name: this.routeName,
      params: {
        ...this.routeParams,
        step
      }
    };
  }

  @Watch("step")
  onStepChanged (): void {
    if ( (!this.step || !this.drivewealthWizardStore.isStepValid(this.step) )
      && this.step !== DrivewealthWizardStep.SelectAccountType) {
      this.$router.replace(this.createLocation(DrivewealthWizardStep.SelectAccountType));
    }
    else if (this.drivewealthWizardStore.firstIncompleteStep !== this.step) {
      this.drivewealthWizardStore.forceStepIncomplete(this.step);
    }
  }

  @Watch("drivewealthWizardStore.firstIncompleteStep")
  onStoreStepChanged (step: DrivewealthWizardStep): void {
    if (step === DrivewealthWizardStep.Completed) {
      this.$emit("wizardComplete");

      return;
    }
    // @ts-ignore
    if (this.$router.history.current.params.step !== step) {
      this.$router.push(this.createLocation(step));
    }
  }

  get showAccountTypeChange (): boolean  {
    return this.step === DrivewealthWizardStep.AccountTypeChange;
  }

  get showChooseAccountType (): boolean  {
    return this.step === DrivewealthWizardStep.SelectAccountType;
  }

  get showRequiredDisclosures (): boolean  {
    return this.step === DrivewealthWizardStep.RequiredDisclosures;
  }

  get showTermsAndConditions (): boolean  {
    return this.step === DrivewealthWizardStep.TermsAndConditions;
  }

  get showCustomerSignature (): boolean  {
    return this.step === DrivewealthWizardStep.CustomerSignature;
  }

  get showManagedQuestionnaire (): boolean  {
    return this.step === DrivewealthWizardStep.PortfolioSelection;
  }

  get showConfirmManagedPortfolio (): boolean  {
    return this.step === DrivewealthWizardStep.PortfolioConfirmation;
  }

  get showAutomatedFunding (): boolean  {
    return this.step === DrivewealthWizardStep.AutomatedFunding;
  }

  get showRiskToleranceQuestionnaire (): boolean  {
    return this.step === DrivewealthWizardStep.RiskToleranceQuestionnaire;
  }
}
